import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { ActiveBadge } from '../../shared/components/ActiveLabel';
import LinkButton from '../../shared/components/LinkButton';
import RouterUtils from '../../shared/routing/RouterUtils';
import { PsRoutes } from '../../shared/routing/Routes';
import { PsTable } from '../../shared/components/table/PsTable';

class ContractorsTable extends React.Component {

    renderHead() {
        return (
            <tr>
                <th>{I18nUtils.tr('TR_ESTADO')}</th>
                <th>{I18nUtils.tr('TR_EMPRESA')}</th>
                <th>{I18nUtils.tr('TR_NIF')}</th>
                <th>{I18nUtils.tr('TR_ADMINISTRADORES')}</th>
                <th>{I18nUtils.tr('TR_CONTACTO')}</th>
                <th />
            </tr>
        );
    }

    render() {
        const {
            loading,
            contractors,
        } = this.props;

        if ( loading ) return null;

        const empty = !contractors || contractors.length === 0;

        if ( empty ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>
                        {I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS')}
                    </h3>
                </section>
            );
        }

        return (
            <PsTable headings={this.renderHead()}>
                {
                    contractors.map(contractor => {
                        const {
                            id,
                            name,
                            nif,
                            admins,
                            disabled,
                            company: {
                                contact_person,
                            },
                        } = contractor;

                        return (
                            <tr key={id}>
                                <td>
                                    <ActiveBadge active={!disabled} />
                                </td>
                                <td>{name}</td>
                                <td>{nif}</td>
                                <td>
                                    {
                                        admins.map((admin) =>
                                            <div key={admin.id}>{admin.email}</div>,
                                        )
                                    }
                                </td>
                                <td>{contact_person}</td>
                                <td>
                                    <LinkButton
                                        to={RouterUtils.generateRoute(PsRoutes.CONTRACTORS_EDIT, { id })}
                                        text={I18nUtils.tr('TR_EDITAR')}
                                        className={'btn-block btn-sm'}
                                    />
                                </td>
                            </tr>
                        );
                    })
                }
            </PsTable>
        );
    }

}

export default ContractorsTable;

ContractorsTable.propTypes = {
    contractors: PropTypes.array,
    loading: PropTypes.bool.isRequired,
};

ContractorsTable.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/contractors/components/ContractorsTable.jsx